import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { screenSmall } from 'components/utils/screen-sizes'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'

const { sysColorLinkMain } = PAYPAL_THEME

export const ieCss = css`
  // IE 11 fix for pp-react bug, missing text input border
  // TODO To remove/verify after pp-react upgrade
  @media screen and (-ms-high-contrast: none) {
    #modalPage .ppvx_text-input__control {
      opacity: 1;
    }
  }
`

export const contentWrapperCss = css`
  padding: 0 8.5rem 4rem;

  @media (max-width: ${screenSmall}) {
    padding: 0 1rem 1.5rem;
  }

  #modal-header {
    text-align: center;
  }
`

export const routerLinkCss = css`
  :hover {
    text-decoration: none;
  }
`

// LoadingSpinnerWithCardImage
export const modalHeaderCss = css`
  margin-top: 4.5rem;
  text-align: center;
`

export const modalContentCss = css`
  display: flex;
  justify-content: center;
  margin-top: -0.1rem;
`

export const imageCss = (src) => css`
  width: 7rem;
  height: 7rem;
  background-image: url('${src}');
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
`

export const headerTextCss = css`
  margin: 2rem 0;
`

export const psTextCss = ({ textWithButton }) => css`
  margin-bottom: 1rem;

  a {
    font-size: inherit;
    line-height: inherit;
    color: ${sysColorLinkMain};
    font-weight: bold;
  }

  ${textWithButton &&
  `span::before {
      content: '•';
      margin-right: .5rem;
    }
  `}
`

export const buttonCss = css`
  margin: 3rem auto 0;
  display: flex !important;
  justify-content: center;
`

export const buttonLoadingCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`

export const spinnerCss = css`
  /* Target all possible spinner elements */
  svg {
    stroke: white !important;
    stroke-width: 3 !important;
  }
  circle {
    stroke: white !important;
    stroke-width: 3 !important;
    fill: none !important;
  }
  path {
    stroke: white !important;
    stroke-width: 3 !important;
    fill: none !important;
  }
  /* PayPal specific classes */
  .ppvx_loading-spinner__svg {
    stroke: white !important;
    stroke-width: 3 !important;
  }
  .ppvx_loading-spinner__circle {
    stroke: white !important;
    stroke-width: 3 !important;
  }
  /* Generic spinner classes */
  .loading-spinner svg {
    stroke: white !important;
    stroke-width: 3 !important;
  }
  .loading-spinner circle {
    stroke: white !important;
    stroke-width: 3 !important;
  }
`

export const ButtonGroup = styled.div`
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  button {
    margin: 0;
  }

  @media (max-width: ${screenSmall}) {
    grid-template-columns: none;
    width: 100%;
  }
`

export const modalTitleCss = css`
  font-family: PayPalOpen-Regular, 'Helvetica Neue', Arial, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const termsMessageText = css`
  color: #666; 
  font-family: 'PaypalPlain-Regular'; 
  font-size: 0.8rem; 
`
export const termLinkCss = css`
  text-decoration: underline;
  font-size: 0.8rem;
`